import { motion } from 'framer-motion';

const Quote = () => {
  return (
    <div className="bg-dark py-20">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-4xl mx-auto"
        >
          <blockquote className="text-2xl text-white italic">
            "Success begins with a single step. Believe in your potential, seize opportunities, and never give up. Your dedication and perseverance will turn dreams into reality. Start your journey to greatness today!"
          </blockquote>
        </motion.div>
      </div>
    </div>
  );
}

export default Quote;